<template>
  <div class="add-user-form">
    <div class="md-layout">
      <div class="md-layout-item md-size-100 md-small-size-100 p-4">
        <div
          :class="getClassBox()"
          class="md-layout-item md-small-size-100 float-left"
        >
          <div class="p-2 mb-2" :class="anonymous ? '' : 'card'">
            <div class="md-field md-form-group">
              <i class="material-icons md-icon">face</i>
              <label>{{ $t("name") }}</label>
              <input
                class="md-input"
                v-model="form.name"
                type="text"
                @input="clearError('name')"
                :required="requiredfields.includes('name')"
                :placeholder="errors.name ? errors.name : ''"
              />
            </div>
            <div
              class="md-field md-form-group"
              :class="errors.email ? 'md-error' : ''"
            >
              <i class="material-icons md-icon">email</i>
              <label v-if="errors.email" class="md-error">
                {{ errors.email }}</label
              >
              <label v-else>Email</label>
              <input
                class="md-input"
                v-model="form.email"
                type="email"
                @input="validateEmail"
                :required="requiredfields.includes('email')"
              />
            </div>
            <div
              class="md-field md-form-group"
              :class="errors.phone ? 'md-error' : ''"
            >
              <i class="material-icons md-icon">phone</i>
              <label v-if="errors.phone" class="md-error">
                {{ errors.phone }}</label
              >
              <label v-else>Teléfono</label>
              <input
                class="md-input"
                v-model="form.phone"
                type="phone"
                :required="requiredfields.includes('phone')"
              />
            </div>
            <div class="md-field md-form-group">
              <i class="material-icons md-icon">cake</i>
              <label class="md-label label">Fecha de nacimiento</label>
              <input
                class="md-input"
                v-model="form.birthdate"
                type="date"
                placeholder="-"
                @input="clearError('birthdate')"
                :required="requiredfields.includes('birthdate')"
              />
            </div>

            <div
              class="mt-3"
              v-if="!hide.includes('stablishment') && formrole == 'client'"
            >
              <div class="align-left text-primary">
                <i class="material-icons text-primary">chat</i>
                <small class="text-secondary"
                  >Si elijes un establecimiento en particular, entonces tu
                  cliente no tendrá permitido ingresar en otro. Dejalo vacío en
                  caso contrario.</small
                >
              </div>
              <div class="md-field">
                <i class="material-icons md-icon">house</i>

                <label
                  class="md-form-label mt-0 pt-0"
                  v-if="!stablishmentId[0] !== false"
                  >{{ $t("stablishments") }}</label
                >
                <select
                  class="md-select"
                  multiple
                  v-if="allStablishments"
                  v-model="stablishmentId"
                >
                  <option
                    v-for="stabl in allStablishments"
                    :key="stabl._id"
                    :value="stabl._id"
                  >
                    {{ stabl.name }}
                  </option>
                </select>
              </div>

              <div
                class="mt-2"
                v-if="!hide.includes('identifier') && formrole == 'client'"
              >
                <div class="mt-3 align-left text-primary" v-if="!anonymous">
                  <i class="material-icons text-primary">chat</i>
                  <small class="text-secondary"
                    >{{ $t("accessIdentifierInfo") }}
                    <strong
                      ><br />({{ $t("leaveEmptyForEmail") }})</strong
                    ></small
                  >
                </div>
                <div class="my-2 align-left text-primary" v-if="anonymous">
                  <i class="material-icons text-primary">chat</i>
                  <small
                    >Utilizarás tu DNI o cualquier identificador para ingresar
                    al gimnasio y ver tu información</small
                  >
                </div>
                <div
                  class="md-field md-form-group"
                  :class="errors.identifier ? 'md-error' : ''"
                >
                  <i class="material-icons md-icon">key</i>
                  <label v-if="errors.identifier" class="md-error">
                    {{ errors.identifier }}</label
                  >
                  <label v-else>DNI o algún identificador</label>
                  <input
                    class="md-input"
                    v-model="form.identifier"
                    @input="clearError('identifier')"
                    type="text"
                    :required="requiredfields.includes('identifier')"
                  />
                </div>
              </div>
            </div>

            <div class="md-field md-form-group" v-if="!hide.includes('password')">
              <i class="material-icons md-icon">lock_outline</i>
              <label>Password</label>
              <input
                class="md-input"
                v-model="form.password"
                type="password"
                @input="validatePassword"
                :required="requiredfields.includes('password')"
                :placeholder="errors.password ? errors.password : ''"
              />
            </div>
            <small v-if="errors.passwordpattern" class="error">{{
              errors.passwordpattern
            }}</small>

            <div class="md-field md-form-group" v-if="!hide.includes('role')">
              <i class="material-icons md-icon">supervisor_account</i>
              <label>Role</label>
              <select
                class="md-select"
                v-if="formrole"
                v-model="formrole"
                @change="onRoleChange"
                :required="requiredfields.includes('role')"
              >
                <option
                  v-for="role in availableRoles"
                  :key="role._id || (typeof role === 'object' ? role.name : role) || role"
                  :value="typeof role === 'object' ? (role.name || role._id) : role"
                >
                  {{ typeof role === 'object' ? (role.label || role.name || (role.name ? $t(role.name + "_role") : role._id)) : $t(role + "_role") }}
                </option>
              </select>
              <span v-if="errors.role" class="error">{{ errors.role }}</span>
            </div>

            <div
              class="md-layout-item md-size-100 md-small-size-100 text-center"
            >
              <div
                class="mt-2 align-left text-primary"
                v-if="
                  !hide.includes('avatar') &&
                  this.form.role == 'client' &&
                  anonymous
                "
              >
                <i class="material-icons text-primary">chat</i> "<small>{{
                  $t("uploadImageMessage")
                }}</small
                >"
              </div>
              <div class="file-input img-circle mt-2">
                <avatar :logo="logo"></avatar>
                <div class="button-container" v-if="!isLoading">
                  <button
                    class="md-button md-danger md-round"
                    @click="removeImage()"
                    v-if="logo"
                  >
                    <i class="fa fa-times"></i>{{ $t("remove") }}
                  </button>
                  <button class="md-button md-success md-round md-fileinput">
                    <template v-if="!logo">{{ $t("selectImage") }}</template>
                    <template v-else>{{ $t("change") }}</template>
                    <input
                      type="file"
                      accept=".png, .jpg, .jpeg"
                      @change="onLogoChange"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="md-layout-item md-size-50 md-small-size-100 float-left p-4"
          v-if="!hide.includes('imc') && !isGym()"
        >
          <h5>Índice de masa corporal</h5>
          <div class="md-field md-form-group">
            <i class="material-icons md-icon">height</i>
            <label>{{ $t("height") }}</label>
            <select class="md-select" v-model="form.height">
              <option :value="false">- Vacio -</option>
              <option v-for="item in altura" :key="item" :value="item"
                >{{ item }} cm</option
              >
            </select>
          </div>
          <div class="md-field md-form-group">
            <i class="material-icons md-icon">scale</i>
            <label>{{ $t("weight") }}</label>
            <select class="md-select" v-model="form.weight">
              <option :value="false">- Vacio -</option>
              <option v-for="item in peso" :key="item" :value="item"
                >{{ item }} kg</option
              >
            </select>
          </div>
          <div class="md-field md-form-group">
            <i class="material-icons md-icon">person</i>
            <label>{{ $t("Edad") }}</label>
            <select class="md-select" v-model="form.age">
              <option :value="false">- Vacio -</option>
              <option v-for="item in age" :key="item" :value="item"
                >{{ item }} años</option
              >
            </select>
          </div>
          <div class="md-field md-form-group">
            <i class="material-icons md-icon">wc</i>
            <label>{{ $t("gender") }}</label>
            <select class="md-select" v-model="form.gender">
              <option :value="false">- Ninguno -</option>
              <option value="F">Femenino</option>
              <option value="M">Masculino</option>
            </select>
          </div>
          <div class="md-layout-item md-size-100 md-small-size-100">
            <div class="px-4 float-left">
              <strong class="text-primary">{{ calcularIMC() }}</strong>
            </div>
            <div>
              <img :src="imc" />
            </div>
          </div>
        </div>

        <div
          class="card p-2 mb-2 w-100"
          v-if="
            config.length > 0 &&
            !anonymous &&
            !hide.includes('paymentType') &&
            form.role == 'client'
          "
        >
          <strong>Precargar un plan de pago creado anteriormente</strong>
          <small
            >Este listado se irá cargando a medida que vayas guardando planes de
            pagos para tus clientes</small
          >

          <div
            class="md-field md-form-group"
            v-if="!hide.includes('config') && config.length"
          >
            <i class="material-icons md-icon">settings</i>
            <label>Mis planes de pago</label>

            <select
              class="md-select px-3"
              v-model="myconfig_id"
              @change="choseConfig()"
            >
              <option
                class="ml-3"
                v-for="conf in config"
                :key="conf._id"
                :value="conf._id"
              >
                <strong v-if="conf.price"
                  >{{ conf.price }}$<small v-if="conf.paymentType == 'month'">
                    {{ $t("perMonth") }}</small
                  >:</strong
                >
                <small> {{ getPaymentMessage(conf) }} </small>
              </option>
            </select>
            <span v-if="errors.role" class="error">{{ errors.role }}</span>
          </div>
        </div>

        <div
          class="card p-2"
          v-if="
            !anonymous && !hide.includes('paymentType') && form.role == 'client'
          "
        >
          <strong>Plan de pago</strong>

          <h5 class="p-2 text-primary text-left">
            <small>{{
              getPaymentMessage({
                paymentType,
                access: unlimitedAccess ? -1 : form.access,
                cupos: unlimitedQuota ? -1 : form.cupos,
              })
            }}</small>
          </h5>
          <div class="md-field md-form-group" v-if="paymentType == 'month'">
            <i class="material-icons md-icon">assignment_ind</i>
            <label>{{ $t("paymentDate") }}</label>
            <input
              class="md-input"
              v-model="form.paymentDate"
              type="date"
              @input="clearError('paymentDate')"
              :required="requiredfields.includes('paymentDate')"
              :placeholder="errors.paymentDate ? errors.paymentDate : ''"
            />
          </div>

          <div class="md-field md-form-group">
            <i class="material-icons md-icon">paid</i>
            <label>{{ $t("paymentMethod") }}</label>
            <select
              class="md-select"
              v-model="form.paymentType"
              @change="clearError('paymentType')"
              :required="requiredfields.includes('paymentType')"
            >
              <option key="month" value="month">
                {{ $t("monthlyPayment") }}
              </option>
              <option key="access" value="access">
                {{ $t("paymentPerAccessOrQuota") }}
              </option>
            </select>
            <span v-if="errors.paymentType" class="error">{{
              errors.paymentType
            }}</span>
          </div>

          <div class="md-size-100 pl-2">
            <div class="md-field">
              <i class="material-icons md-icon">paid</i>
              <label>{{ $t("productPrice") }}</label>
              <input
                class="md-input"
                min="0"
                type="Number"
                v-model="form.price"
                inputmode="decimal"
                @input="clearError('price')"
              />
            </div>
          </div>

          <div class="mb-2">
            <div class="md-size-100 mt-4 pl-2">
              <i class="material-icons text-primary">chat</i> "<small
                class="text-secondary"
                >{{ $t("allowedAccessCount")
                }}<span class="text-black" v-if="paymentType == 'month'">
                  ({{ $t("perMonth") }})</span
                ></small
              >"

              <div class="md-field my-0 py-0" v-if="paymentType == 'month'">
                <label class="md-checkbox">
                  <input
                    type="checkbox"
                    v-model="unlimitedAccess"
                    @change="clearError('unlimitedAccess')"
                  />
                  {{ $t("unlimitedAccess") }}
                </label>
              </div>

              <div class="md-field" v-if="!unlimitedAccess">
                <i class="material-icons md-icon">meeting_room</i>
                <label>{{ $t("accesses") }}</label>
                <input class="md-input" min="0" type="text" v-model="form.access" />
              </div>
            </div>
          </div>

          <div class="mb-2">
            <div class="md-size-100 mt-4 pl-2">
              <i class="material-icons text-primary">chat</i>
              "<small class="text-secondary"
                >{{ $t("classLimitPerMonth")
                }}<span class="text-black" v-if="paymentType == 'month'">
                  ({{ $t("perMonth") }})</span
                ></small
              >"

              <div class="md-field my-0 py-0" v-if="paymentType == 'month'">
                <label class="md-checkbox">
                  <input
                    type="checkbox"
                    v-model="unlimitedQuota"
                    @change="clearError('unlimitedQuota')"
                  />
                  {{ $t("unlimitedQuota") }}
                </label>
              </div>
              <div class="md-field" v-if="!unlimitedQuota">
                <i class="material-icons md-icon">self_improvement</i>
                <label>{{ $t("quota") }}</label>
                <input class="md-input" min="0" type="text" v-model="form.cupos" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="loading-container mr-2" v-if="isLoading">
      <div class="md-progress-spinner md-secondary mr-2"></div>
    </div>

    <strong v-if="errorMessage" class="text-danger">{{
      $t(errorMessage)
    }}</strong>

    <button
      class="md-button md-small md-primary w-100"
      :disabled="isLoading"
      @click="submitForm"
      >{{ $t("save") }}</button
    >
  </div>
</template>

<script>
// Mock functions to replace non-existent imports
const getAllAction = async () => {
  console.warn(
    "getAllAction is not available - Stablishments actions module was removed"
  );
  return { success: false, data: [] };
};

const uploadImageAction = async (file) => {
  console.warn(
    "uploadImageAction is not available - Products actions module was removed"
  );
  return { success: false, message: "Image upload not available" };
};

import {
  createUserAction,
  createUserAnonymousAction,
} from "@/pages/Users/actions";
import { getPaymentConfigAction } from "@/pages/Auth/actions";
import permissionsMixin from "@/mixins/permissionsMixin";
import Avatar from "@/components/Avatar.vue"; // Ajusta la ruta si es necesario
import Swal from "sweetalert2";

export default {
  mixins: [permissionsMixin],
  components: {
    Avatar,
  },
  props: {
    anonymous: {
      type: Boolean,
      default: () => false,
    },
    roles: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
    },
    required: {
      type: Array,
      default: () => ["name", "email", "password", "role"],
    },
    hide: {
      type: Array,
      default: () => ["identifier", "paymentDate"],
    },
    user: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      isLoading: false,
      myconfig: false,
      isAdmin: false,
      imc: process.env.BASE_URL + "img/imc.png",
      config: [],
      altura: [],
      allStablishments: [],
      stablishmentId: [],
      peso: [],
      age: [],
      avatarImg: "/img/placeholder.jpg",
      selectedLogoFile: "",
      logo: "",
      unlimitedAccess: true,
      unlimitedQuota: false,
      formrole: "",
      errorMessage: "",
      paymentType: "month",
      myconfig_id: false,
      form: {
        requiredfields: false,
        name: "",
        email: "",
        password: "",
        identifier: "",
        role: "",
        phone: "",
        birthdate: "",
        height: "",
        weight: "",
        age: "",
      },
      errors: {},
    };
  },
  computed: {
    todayDate() {
      // Obtén la fecha actual en el formato 'YYYY-MM-DD'
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    // Filtrar roles disponibles - solo permitir roles con 'all_access' si el usuario actual tiene 'all_access'
    availableRoles() {
      if (this.isAdmin) {
        return this.roles; // Mostrar todos los roles si tiene all_access
      } else {
        // Excluir roles que tengan 'all_access' si el usuario no lo tiene
        return this.roles.filter((role) => {
          // Si el rol tiene permisos definidos, verificar si tiene 'all_access'
          if (role.permissions && Array.isArray(role.permissions)) {
            return !role.permissions.includes("all_access");
          }
          // Si no tiene permisos definidos, permitir (roles básicos)
          return true;
        });
      }
    },
  },
  created() {
    // Cargar los permisos del usuario actual
    this.fetchUserPermissions();

    this.altura = Array.from({ length: 250 }, (_, index) => index + 100);
    this.peso = Array.from({ length: 250 }, (_, index) => index + 10);
    this.age = Array.from({ length: 90 }, (_, index) => index + 10);

    this.loadStablishments();

    this.stablishmentId = this.user.stablishments.map(
      (stablishment) => stablishment._id
    );

    if (this.isGym()) {
      this.getPaymentConfig();
    }
    this.requiredfields = this.required;
    this.form.paymentDate = this.todayDate;

    if (!this.hide.includes("role")) {
      if (this.type == "restaurant") {
        this.formrole = "employee";
        this.form.role = "employee";
      }
      if (this.type == "gym" || this.roles.length == 0) {
        this.formrole = "client";
        this.form.role = "client";
      }
    }

    if (!this.form.paymentType) {
      this.form.paymentType = "month";
    }

    if (this.user && this.user._id) {
      this.logo = this.user.avatar;
      this.form._id = this.user._id;
      if (this.user.paymentDate) {
        const today = new Date(this.user.paymentDate); // Convierte la fecha a un objeto Date
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        this.form.paymentDate = `${year}-${month}-${day}`;
      }
      if (this.user.email) {
        this.form.email = this.user.email;
      }
      if (this.user.name) {
        this.form.name = this.user.name;
      }
      if (this.user.price) {
        this.form.price = this.user.price;
      }

      if (this.user.identifier) {
        this.form.identifier = this.user.identifier;
      }
      if (this.user.phone) {
        this.form.phone = this.user.phone;
      }
      if (this.user.height) {
        this.form.height = this.user.height;
      }
      if (this.user.age) {
        this.form.age = this.user.age;
      }
      if (this.user.weight) {
        this.form.weight = this.user.weight;
      }
      if (this.user.gender) {
        this.form.gender = this.user.gender;
      }
      if (this.user.birthdate) {
        this.form.birthdate = this.user.birthdate;
      }
      if (this.user.cupos) {
        this.form.cupos = this.user.cupos;
      }
      if (this.user.role) {
        // Si user.role es un objeto, obtener el nombre, si no usar directamente
        const roleName = typeof this.user.role === 'object' 
          ? (this.user.role.name || this.user.role._id) 
          : this.user.role;
        this.formrole = roleName;
        this.form.role = roleName;
      }

      this.form.access = this.user.access;

      if (this.user.paymentType != "month" && this.user.cupos < 0) {
        this.user.cupos = 0;
      }

      this.form.cupos = this.user.cupos;

      if (this.user.paymentType) {
        this.form.paymentType = this.user.paymentType;
        this.paymentType = this.user.paymentType;
      }

      console.log(this.user);
      if (this.user.access == undefined) {
        this.user.access = -1;
        this.form.access = -1;
      }
      if (this.user.cupos == undefined) {
        this.user.cupos = -1;
        this.form.cupos = -1;
      }

      if (this.user.access < 0) {
        this.unlimitedAccess = true;
      } else {
        this.unlimitedAccess = false;
      }
      if (this.user.cupos < 0) {
        this.unlimitedQuota = true;
      } else {
        this.unlimitedQuota = false;
      }
    } else {
      if (this.roles[0] && !this.hide.includes("role")) {
        // Obtener el nombre del rol (puede ser objeto o string)
        const firstRole = this.roles[0];
        const roleName = typeof firstRole === 'object' ? firstRole.name : firstRole;
        this.formrole = roleName;
        this.form.role = roleName;
      }
    }

    this.getPaymentMessage(this.form);
  },
  methods: {
    // Obtener los permisos del usuario actual desde el backend
    async fetchUserPermissions() {
      try {
        const response = await this.$wencesApi.get("/api/users/myprofile");
        if (response.data.ok) {
          const userData = response.data.data;
          let roleId;

          // Obtener el ID del rol
          if (typeof userData.role === "string") {
            roleId = userData.role;
          } else if (userData.role && userData.role._id) {
            roleId = userData.role._id;
          }

          if (roleId) {
            // Obtener los permisos del rol
            const roleResponse = await this.$wencesApi.get(
              `/api/roles/${roleId}`
            );
            if (
              roleResponse.data.success &&
              roleResponse.data.data &&
              roleResponse.data.data.permissions
            ) {
              const permissions = roleResponse.data.data.permissions;
              // Verificar si tiene el permiso 'all_access'
              this.isAdmin = permissions.includes("all_access");
            }
          }
        }
      } catch (error) {
        console.error("Error fetching user permissions:", error);
        this.isAdmin = false;
      }
    },
    getClassBox() {
      if (this.isGym() || this.anonymous) {
        return "md-size-100";
      }

      return "md-size-50";
    },
    async loadStablishments() {
      const stablishmentsResponse = await getAllAction();
      this.allStablishments = stablishmentsResponse.stablishments;
    },
    calcularIMC() {
      // Validación básica de entrada

      let peso = this.form.weight;
      let altura = this.form.height / 100;
      let genero = this.form.gender;

      if (!peso || !altura) {
        return "";
      }

      // Calcular IMC
      let imc = peso / (altura * altura); // altura en metros
      imc = imc.toFixed(2); // Redondear a dos decimales

      // Clasificación del IMC según la OMS
      let clasificacion = "";
      if (imc < 18.5) {
        clasificacion = "Bajo peso";
      } else if (imc >= 18.5 && imc < 24.9) {
        clasificacion = "Peso normal";
      } else if (imc >= 25 && imc < 29.9) {
        clasificacion = "Sobrepeso";
      } else if (imc >= 30 && imc < 34.9) {
        clasificacion = "Obesidad grado I";
      } else if (imc >= 35 && imc < 39.9) {
        clasificacion = "Obesidad grado II";
      } else {
        clasificacion = "Obesidad grado III";
      }

      // Mensaje adaptado según género
      let mensajeGenero = genero === "F" ? "mujer" : "hombre";

      // Resultado final
      return `El IMC calculado para una ${mensajeGenero} con un peso de ${peso} kg y una altura de ${altura} m es ${imc}.`;
    },
    choseConfig() {
      this.myconfig = this.config.find(
        (element) => element._id === this.myconfig_id
      );

      this.form.cupos = this.myconfig.cupos;
      if (this.myconfig.cupos == -1) {
        this.unlimitedQuota = true;
      } else {
        this.unlimitedQuota = false;
      }
      this.form.access = this.myconfig.access;
      if (this.myconfig.access == -1) {
        this.unlimitedAccess = true;
      } else {
        this.unlimitedAccess = false;
      }
      this.form.paymentType = this.myconfig.paymentType;
      this.paymentType = this.myconfig.paymentType;
      this.form.price = this.myconfig.price;
    },
    async getPaymentConfig() {
      const response = await getPaymentConfigAction();
      this.config = response.data;
    },
    clearError(field) {
      if (field == "paymentType" && this.form.paymentType != "month") {
        this.unlimitedAccess = false;
        this.unlimitedQuota = false;
        if (this.form.cupos == -1) {
          this.form.cupos = 0;
        }
      }
      this.paymentType = this.form.paymentType;

      if (field == "unlimitedAccess" && this.unlimitedAccess) {
        this.form.access = -1;
      }
      if (field == "unlimitedAccess" && !this.unlimitedAccess) {
        this.form.access = 10;
      }
      if (field == "unlimitedQuota" && this.unlimitedQuota) {
        this.form.cupos = -1;
      }
      if (
        field == "unlimitedQuota" &&
        !this.unlimitedQuota &&
        this.form.cupos == -1
      ) {
        this.form.cupos = 10;
      }

      if (field == "role") {
        // formrole ahora contiene el nombre del rol (string), no el objeto
        this.form.role = this.formrole;
        if (this.form.role == "gym") {
          this.requiredfields.push("email");
        }
      }

      if (this.errors[field]) {
        this.$delete(this.errors, field);
      }
    },
    onRoleChange() {
      // Cuando cambia el select, formrole ya contiene el nombre del rol (string)
      this.form.role = this.formrole;
      if (this.form.role == "gym") {
        if (!this.requiredfields.includes("email")) {
          this.requiredfields.push("email");
        }
      }
      this.clearError('role');
    },
    onLogoChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.selectedLogoFile = files[0];
      this.createImagePreview(this.selectedLogoFile, "logo");
    },
    createImagePreview(file, type) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logo = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeLogo() {
      this.logo = "";
      this.selectedLogoFile = null;
    },

    removeImage() {
      this.logo = "";
      this.selectedLogoFile = null;
    },
    validateEmail() {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(this.form.email)) {
        this.errors.email = this.$t("emailInvalid");
      } else {
        this.clearError("email");
      }
    },
    validatePassword() {
      const password = this.form.password;
      const strongPasswordPattern = /^(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{7,}$/;
      if (!strongPasswordPattern.test(password)) {
        this.errors.passwordpattern =
          this.$t("password_needs_symbol") +
          ", " +
          this.$t("password_too_short");
      } else {
        this.clearError("password");
        this.clearError("passwordpattern");
      }
    },
    formValid() {
      return Object.keys(this.errors).length === 0;
    },
    submitForm() {
      this.errors = {};
      this.form.avatar = this.selectedLogoFile;
      this.form.stablishments = this.stablishmentId;

      // Validar que solo un usuario con 'all_access' puede asignar roles con 'all_access'
      // Buscar el rol por nombre ya que form.role ahora contiene el nombre (string)
      const selectedRole = this.roles.find((role) => {
        const roleName = typeof role === 'object' ? role.name : role;
        return roleName === this.form.role;
      });
      if (
        selectedRole &&
        selectedRole.permissions &&
        selectedRole.permissions.includes("all_access") &&
        !this.isAdmin
      ) {
        Swal.fire({
          title: "Error",
          text: "No tienes permisos para asignar roles de administrador",
          icon: "error",
        });
        return;
      }

      this.requiredfields.forEach((field) => {
        if (!this.form[field]) {
          this.errors[field] = `${field} ` + this.$t("nameRequired");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${field} ` + this.$tn("nameRequired"),
          });
        }
      });

      // Check if there are any validation errors
      if (Object.keys(this.errors).length === 0) {
        this.createUser();
      }
    },
    async createUser() {
      if (this.isDemo()) {
        return;
      }

      this.isLoading = true;
      let imageUrl = "";
      if (this.form.avatar) {
        const response = await uploadImageAction(this.form.avatar);
        if (response.ok) {
          imageUrl = response.data.data.Location; // URL de la imagen subida
          this.form.avatar = imageUrl;
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: this.$tn("errorUploadingImage"),
          });

          this.isLoading = false;

          return;
        }
      }

      if (this.form.paymentType) {
        this.paymentType = this.form.paymentType;
      } else {
        this.paymentType = "month";
        this.form.paymentType = "month";
      }

      if (!this.form.identifier) {
        this.form.identifier = this.form.email;
      }

      try {
        let response;
        if (this.anonymous) {
          response = await createUserAnonymousAction(this.form);
        } else {
          response = await createUserAction(this.form);
        }
        if (response.ok) {
          this.isLoading = false;
          this.errorMessage = null;
          this.$emit("userCreated", this.form.identifier);
        } else {
          this.isLoading = false;
          if (
            response.message == "emailExistsMessage" ||
            response.message == "userExists"
          ) {
            this.errors.email = this.$t("emailExistsMessage");
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.$tn("emailExistsMessage"),
            });
          }
          if (response.message == "identifierExistsMessage") {
            this.errors.identifier = this.$t("identifierExistsMessage");
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.$tn("emailExistsMessage"),
            });
          }
          if (response.message == "User already exists") {
            this.errors.identifier = this.$t("identifierExistsMessage");
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: this.$tn("identifierExistsMessage"),
            });
          }
        }
      } catch (error) {
        this.isLoading = false;
        this.errorMessage = "userExists";
      }
    },
    getPaymentMessage(conf) {
      let productName = "";
      if (
        conf.paymentType == "month" &&
        conf.access == -1 &&
        conf.cupos == -1
      ) {
        productName = this.$t("unlimitedMonthlyPayment");
      } else if (
        conf.paymentType == "month" &&
        conf.access == -1 &&
        conf.cupos > -1
      ) {
        productName = this.$t("unlimitedMonthlyPaymentWithQuota", {
          cupos: this.form.cupos,
        });
      } else if (
        conf.paymentType == "month" &&
        conf.access > -1 &&
        conf.cupos == -1
      ) {
        productName = this.$t("limitedAccessUnlimitedQuota", {
          access: this.form.access,
        });
      } else if (
        conf.paymentType == "month" &&
        conf.access > -1 &&
        conf.cupos > -1
      ) {
        productName = this.$t("limitedMonthlyPayment", {
          cupos: this.form.cupos,
          access: this.form.access,
        });
      } else if (
        conf.paymentType != "month" &&
        conf.access > -1 &&
        conf.cupos > -1
      ) {
        productName = this.$t("oneTimePayment", {
          cupos: conf.cupos,
          access: conf.access,
        });
      }

      this.form.productName = productName;

      return productName;
    },
  },
};
</script>

<style scoped>
.margin-auto {
  margin: 0 auto;
}

.md-input.md-select-value {
  margin-left: 11px !important;
}
.md-helper {
  margin-top: -25px;
  margin-left: 35px;
}
.md-required input::placeholder {
  color: red !important;
  opacity: 1; /* Firefox */
}

.md-required input::-ms-input-placeholder {
  /* Edge 12 -18 */
  color: red;
}
.md-field label.text-danger {
  color: red !important;
}
.md-form-group {
  margin-bottom: 20px;
}
.error {
  color: red;
  font-size: 12px;
}
.md-menu.md-select {
  padding-left: 12px;
}
</style>
